var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtnNotificationConfig = function SvgBtnNotificationConfig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "btn-notification-config_svg__mask0_20004_3110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#btn-notification-config_svg__mask0_20004_3110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C9.82843 16.5 10.5 15.8284 10.5 15H7.5C7.5 15.8284 8.17157 16.5 9 16.5Z",
    fill: "#39404D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.6875H15",
    stroke: "#39404D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 13.5V7.77273C4.125 5.13682 6.30761 3 9 3C11.6924 3 13.875 5.13682 13.875 7.77273V13.5",
    stroke: "#39404D",
    strokeWidth: 1.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125V2.625",
    stroke: "#39404D",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgBtnNotificationConfig;